import styled, { DefaultTheme } from 'styled-components';
import { getSpacingToken } from '@optimus-web/common';
import { Stack } from '../Stack';
import { MewsLogoProduct, MewsLogoSize } from './types';

export const getLogoHeight = ({ size, theme }: { size: MewsLogoSize; theme: DefaultTheme }) => {
    switch (size) {
        case 'small':
            return getSpacingToken('100')({ theme });
        case 'medium':
            return getSpacingToken('200')({ theme });
        case 'large':
            return getSpacingToken('300')({ theme });
    }
};

export const getLogoProductHeight = ({ size, theme }: { size: MewsLogoSize; theme: DefaultTheme }) => {
    switch (size) {
        case 'small':
            return getSpacingToken('150')({ theme });
        case 'medium':
            return getSpacingToken('250')({ theme });
        case 'large':
            return getSpacingToken('400')({ theme });
    }
};

const getLogosGap = ({ size, theme }: { size: MewsLogoSize; theme: DefaultTheme }) => {
    switch (size) {
        case 'small':
            return getSpacingToken('50')({ theme });
        case 'medium':
            return getSpacingToken('150')({ theme });
        case 'large':
            return getSpacingToken('200')({ theme });
    }
};

interface MewsLogoWrapperProps {
    size: MewsLogoSize;
    protectiveArea?: boolean;
    product?: MewsLogoProduct;
}

export const MewsLogoWrapper = styled(Stack)<MewsLogoWrapperProps>`
    padding: ${(props) => props.protectiveArea && `${getLogoHeight(props)}px`};
    gap: ${(props) => props.product && `${getLogosGap(props)}px`};
`;

interface LogoSvgProps {
    size: MewsLogoSize;
}

export const MewsLogoSvg = styled.svg<LogoSvgProps>`
    height: ${getLogoHeight}px;
    width: auto;
    display: block;
`;

export const ProductLogoSvg = styled.svg<LogoSvgProps>`
    height: ${getLogoProductHeight}px;
    width: auto;
    display: block;
`;
